import React from "react";
import "./style.scss";

import getCohort from "./img/get-cohort.png";
// import howToHost from "./img/how-to-host-cohort.png";
import howToHost from "./img/how-to-host-cohort2.svg";
import inviteStart from "./img/invite-startup.png";
import keyFunBG from "./img/key-function-bg.png";
import mangeCohort from "./img/manage-cohort.png";
import registerCohort from "./img/register-cohort.png";
import selectMatch from "./img/select-&-match.png";
import HTMLReactParser from "html-react-parser";
import { useTranslation } from 'react-i18next';
export default function HowToHost(props) {
  const keyData = props.data;
  const { t } = useTranslation();
  return (
    <div>
      <section
        style={{
          background: "url('./img/key-function-bg.png')",
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        id="unique" 
      >
        <div  class="w-100 pt-50 pb-4 position-relative">
          <div class="container">
            <div class="row">
              <div class="sec-title text-center w-100 position-relative">
                <h2 class="mb-0 homepageFirstHeader">
                {t('How_to_host_a_Cohort_Program')}
                  {/* How to host a Cohort Program on the MAARG Portal */}
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div class="container" id="line">
          <div class="row wow fadeInDown">
            <div
              class="col-md-12 col-sm-6 col-lg-12"
              style={{
                padding: "0px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <img src={howToHost} style={{ width: "90%" }} />
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row pt-20 wow fadeInDown">
            {keyData.map((data, index) => {
              return (
                <div class="col" key={index}>
                  <div class="unique-sec">
                    <a class="cohort-heading homepageFirstDescription" style={{ fontSize: "20px" }}>
                      {data.Heading}
                    </a>
                    <div className="homepageFirstDescription" >
                    {HTMLReactParser(data.Text)}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
      {/* <!-- new section mobile--> */}
      <section
        style={{
          background: "url('./img/key-function-bg.png')",
          backgroundPosition: "center",
          backgroundSize: "cover",
        }}
        id="unique-mobile"
      >
        <div class="w-100 pt-50 pb-50 position-relative">
          <div class="container">
            <div class="row">
              <div class="sec-title text-center w-100 position-relative">
                <h2 class="mb-0">
                  How to host a Cohort Program on the MAARG Portal
                </h2>
              </div>
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-md-2 col-sm-6 col-lg-2">
              <div class="unique-sec">
                <img src={registerCohort} />
                <br />
                <a class="cohort-heading">{keyData[0].Heading}</a>
                {HTMLReactParser(keyData[0].Text)}
              </div>
            </div>
            <div class="col-md-2 col-sm-6 col-lg-2">
              <div class="unique-sec">
                <img src={getCohort} />
                <br />
                <a class="cohort-heading">{keyData[1].Heading}</a>
                {HTMLReactParser(keyData[1].Text)}
              </div>
            </div>
            <div class="col-md-2 col-sm-6 col-lg-2">
              <div class="unique-sec">
                <img src={inviteStart} /> <br />
                <a class="cohort-heading">{keyData[2].Heading}</a>
                {HTMLReactParser(keyData[2].Text)}
              </div>
            </div>
            <div class="col-md-2 col-sm-6 col-lg-2">
              <div class="unique-sec">
                <img src={selectMatch} />
                <br />
                <a class="cohort-heading">{keyData[3].Heading}</a>
                {HTMLReactParser(keyData[3].Text)}
              </div>
            </div>
            <div class="col-md-2 col-sm-6 col-lg-2">
              <div class="unique-sec">
                <img src={mangeCohort} />
                <br />
                <a class="cohort-heading">{keyData[4].Heading}</a>
                {HTMLReactParser(keyData[4].Text)}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
